import { useState } from "react";
import  "./AromaDryIntensity.css";


const AromaDryIntensity = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.aromadryintensity===0?0:data.aromadryintensity);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="densityradiocard" name="aromadryintensity" onChange={onChangeValue}>
    <div class="densityrating-container">
 
      <div class="densityrating">
        <form class="densityrating-form-1" >

          <label for={`ADD1F-${count}`}>
        <input type="radio"  name="aromadryintensity" class="density1" id={`ADD1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>

          <label for={`ADD2F-${count}`}>
        <input type="radio" name="aromadryintensity" class="density2" id={`ADD2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>

          <label for={`ADD3F-${count}`}>
        <input type="radio" name="aromadryintensity" class="density3" id={`ADD3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>

          <label for={`ADD4F-${count}`}>
        <input type="radio" name="aromadryintensity" class="density4" id={`ADD4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>

        </label>

          <label for={`ADD5F-${count}`}>
        <input type="radio" name="aromadryintensity" class="density5" id={`ADD5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>


    );
}

export default AromaDryIntensity;